import { COLOR, Icon as _Icon } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivWrapper = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px 0;

  &:focus-visible {
    outline: 2px solid ${COLOR.YELLOW900.code};
    outline-offset: -2px;
  }
`;

export const IconLinkItem = styled(_Icon)`
  margin-left: 16px;
`;
